import React, { useMemo } from "react";

import { ColumnsType } from "antd/es/table";
import { useIntl } from "react-intl";

import { Activity, Company, Deal, Person } from "@mapmycustomers/shared/types/entity";

import ActivityAssignee from "@app/component/activity/ActivityAssignee";
import ActivityDate from "@app/component/activity/ActivityDate";
import ActivityName from "@app/component/activity/ActivityName";

import NoteCellRenderer from "../NoteCellRenderer";
import styles from "../PreviewActivityListModal.module.scss";

export const useActivityListColumns = (
  onCompanyPreview: (companyId: Company["id"]) => void,
  onDealPreview: (dealId: Deal["id"]) => void,
  onPersonPreview: (personId: Person["id"]) => void
): ColumnsType<Activity> => {
  const intl = useIntl();
  return useMemo(
    () => [
      {
        dataIndex: "activity",
        key: "activity",
        render: (ignore: any, activity: Activity) => (
          <ActivityName
            activity={activity}
            onCompanyClick={onCompanyPreview}
            onDealClick={onDealPreview}
            onPersonClick={onPersonPreview}
          />
        ),
        title: intl.formatMessage({
          id: "activityListModal.activityList.column.activity",
          defaultMessage: "Activity",
          description:
            "Title of a Activity column in activities table on Activities Modal on Home page",
        }),
      },
      {
        dataIndex: "date",
        key: "date",
        render: (_: any, activity: Activity) => <ActivityDate activity={activity} />,
        title: intl.formatMessage({
          id: "activityListModal.activityList.column.date",
          defaultMessage: "Date",
          description:
            "Date of a Activity column in Activities table on Activities Modal on Home page",
        }),
      },
      {
        dataIndex: "assignee",
        key: "assignee",
        render: (name: string, activity: Activity) => <ActivityAssignee activity={activity} />,
        title: intl.formatMessage({
          id: "activityListModal.activityList.column.assignee",
          defaultMessage: "Assigned to",
          description:
            "Title of Assigned to column in Activity table on Activities Modal on Home page",
        }),
        width: "15%",
      },
      {
        className: styles.secondaryCol,
        dataIndex: "note",
        key: "note",
        render: (_, activity: Activity) => <NoteCellRenderer activity={activity} />,
        title: intl.formatMessage({
          id: "activityListModal.activityList.column.note",
          defaultMessage: "Note",
          description:
            "Title of a Note column in Company table on Activities Modal on Overview page",
        }),
      },
    ],
    [intl, onCompanyPreview, onPersonPreview, onDealPreview]
  );
};
